/* eslint-disable prefer-const */
/* eslint-disable max-statements */
import { brand, green, orange, red } from '../theme/themePrimitives';
import { CalendarEventObject, TransformedCalendarEventObject } from '../params/redux/calendar';

const convertTo24Hour = (time12h: string): string => {
   const [time, modifier] = time12h.split(' ');
   let [hours, minutes] = time.split(':').map(Number);

   if (modifier === 'PM' && hours !== 12) {
      hours += 12;
   }
   if (modifier === 'AM' && hours === 12) {
      hours = 0;
   }

   return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

export const transformedEvents = (data: CalendarEventObject[]): TransformedCalendarEventObject[] => {
   const dataToSend = data
      .filter((event) => event.type?.toLowerCase() === 'meeting')
      .map((event) => {
         const defaultDate = new Date('1970-01-01T00:00:00Z');
         // Compute start time
         let startDate: Date = defaultDate;
         if (event.start_date) {
            startDate = new Date(event.start_date);
         } else if (event.set_date && event.set_time) {
            const normalizedTime = convertTo24Hour(event.set_time);
            startDate = new Date(`${event.set_date}T${normalizedTime}`);
         } else {
            startDate = defaultDate;
         }

         // Compute end time using duration
         let endDate: Date = defaultDate;
         if (event.end_date) {
            endDate = new Date(event.end_date);
         } else if (event.duration) {
            const durationMinutes = parseInt(event.duration, 10);
            endDate = new Date((startDate.getTime() + (durationMinutes * 60000)));
         } else {
            endDate = defaultDate;
         }

         const id = event.id || `event-${Math.random().toString(36)
            .substr(2, 9)}`;
         const title = event.event_name || 'Untitled Event';
         const desc = event.description || '';
         const allDay = !event.start_date && !event.set_date;
         const attendees = event.meeting_attendees || [];
         const googleMeetLink = event.meeting_link;

         const color = (() => {
            switch (event.color_tag) {
               case 'primary': return brand[300];
               case 'success': return green[400];
               case 'warning': return orange[300];
               case 'danger': return red[300];
               default: return red[300];
            }
         })();
         return {
            id,
            title,
            start: startDate.toISOString(),
            end: endDate.toISOString(),
            desc,
            allDay,
            color,
            attendees,
            googleMeetLink,
            type: 'event' as 'event' | 'reminder'
         };
      });
   return dataToSend;
};


export const transformedReminders = (data: {
   id: number;
   deal_id: number;
   title: string;
   description: string;
   due_date: string;
   due_time: string | null;
   status: 'active' | 'inactive';
   created_at: string;
   updated_at: string;
}[]): TransformedCalendarEventObject[] => {
   const dataToSend = data
      .map((event) => {
         const defaultDate = new Date(`1970-01-01T${event.due_time}:00`);
         // Compute start time
         let startDate: Date = defaultDate;
         let endDate: Date = defaultDate;
         const isTimed = event.due_date && event.due_time;

         if (isTimed) {
            startDate = new Date(`${event.due_date}T${event.due_time}:00`);
            endDate = new Date(`${event.due_date}T${event.due_time}:00`);
         } else if (event.due_date) {
            startDate = new Date(`${event.due_date}T05:00:00`);
            endDate = new Date(`${event.due_date}T05:01:59`);
         } else {
            startDate = new Date();
            endDate = new Date();
         }
         const id = event.id || `event-${Math.random().toString(36)
            .substr(2, 9)}`;
         const title = event.title || 'Untitled Event';
         const desc = event.description || '';
         const allDay = !event.due_date;
         const attendees = [] as [];
         const googleMeetLink = '';

         const [color] = [green[400]];
         return {
            id,
            title,
            start: startDate.toISOString(),
            end: endDate.toISOString(),
            desc,
            allDay,
            color,
            attendees,
            googleMeetLink,
            type: 'reminder' as 'event' | 'reminder',
            deal_id: event.deal_id
         };
      });
   return dataToSend;
};